export default {
  EDIT_CUSTOM_GOAL_PLAN_STATE_MANAGER: Symbol.for('EDIT_CUSTOM_GOAL_PLAN_STATE_MANAGER'),
  EDIT_CUSTOM_GOAL_CURRENT_PLAN_SERVICE: Symbol.for('EDIT_CUSTOM_GOAL_CURRENT_PLAN_SERVICE'),
  EDIT_CUSTOM_GOAL_PLAN_DEFINE_BY_SERVICE: Symbol.for('EDIT_CUSTOM_GOAL_PLAN_DEFINE_BY_SERVICE'),
  EDIT_CUSTOM_GOAL_PLAN_INITIAL_AMOUNT_SERVICE: Symbol.for('EDIT_CUSTOM_GOAL_PLAN_INITIAL_AMOUNT_SERVICE'),
};
